import { Component, Input, OnInit } from '@angular/core';
import { TimelineModel } from '../../../shared/models/timeline.model';

@Component({
    selector: 'app-kamona-stepper',
    templateUrl: './kamona-stepper.component.html',
    styleUrls: ['./kamona-stepper.component.scss'],
})
export class KamonaStepperComponent implements OnInit {
    @Input() timelines: TimelineModel[] = [];
    readonly TimelineStatus = TimelineStatus;
    constructor() {}

    ngOnInit(): void {}
}

export enum TimelineStatus {
    active = 'active',
    completed = 'completed',
    inactive = 'inactive',
    processing = 'processing',
    incomplete = 'incomplete',
    re_do = 're-do',
    failed = 'failed',
    in_review = 'in_review',
    success = 'success',
}
